export default __webpack_public_path__ + "static/media/1Place-logo.9c9ae4f1.png";